import { Build } from '@stencil/core';
import type { ICarpentryComponent } from '~/interfaces/ICarpentryComponent';

const cache = new Set<string>();

if (Build.isDev || Build.isTesting) {
  window.ltanalytics = {
    track: (...args: unknown[]) => {
      console.log('>>> Tracking\n', ...args.map((arg) => `>>> ${JSON.stringify(arg, null, 2)}\n`));
    },
    getTrackProperties() {
      return { esourceid: 'esourceid', ClickSessionId: 'ClickSessionId', mtaid: 'mtaid' };
    },
  };
}

export interface IWidgetTracking {
  calculator_used?: string;
  component?: string;
  extra_query_param?: string;
  footer_displayed?: boolean;
  footer_icon?: string;
  footer_text?: string;
  headline_tag?: string;
  headline_text?: string;
  inputs_included?: string;
  page_id?: string;
  post_id?: string;
  product?: string;
  theme?: string;
}

export const WidgetTrack = (event: string, params: IWidgetTracking = {}): void => {
  // Backward compatibility
  params.calculator_used = params.component;

  const bodyClasses = Array.from(window.document.body.classList);
  const postId = bodyClasses.find((a) => a.startsWith('postid-'));
  const pageId = bodyClasses.find((a) => a.startsWith('page-id-'));

  const trackData: IWidgetTracking = {
    ...params,
    ...(postId ? { post_id: postId.replace('postid-', '') } : {}),
    ...(pageId ? { page_id: pageId.replace('page-id-', '') } : {}),
  };

  window.ltanalytics?.track(event, trackData);
};

export const WidgetUsed = (comp: ICarpentryComponent, additionalProps: IWidgetTracking = {}): void => {
  WidgetTrack('Widget Used', { component: comp.host.tagName.toLowerCase(), ...additionalProps });
};

export const WidgetClicked = (comp: ICarpentryComponent, additionalProps: IWidgetTracking = {}): void => {
  WidgetTrack('Widget Clicked', { component: comp.host.tagName.toLowerCase(), ...additionalProps });
};

export const WidgetLoaded = (comp: ICarpentryComponent, additionalProps: IWidgetTracking = {}): void => {
  if (!Build.isServer) {
    WidgetTrack('Widget Loaded', { component: comp.host.tagName.toLowerCase(), ...additionalProps });
  }
};

export const AIChatbotTrack = (event: string) => {
  window.ltanalytics?.track(event, {
    'Page Name': document.title,
  });
};

export const callUniqueEntry = (id: string, trackFunc: () => void) => {
  if (!cache.has(id)) {
    cache.add(id);
    trackFunc();
  }
};

export const trackMenuClick = (menuName: string) => {
  window.ltanalytics?.track('Navigation Click', { clicked_content: menuName });
};
